import { cloneElement, useEffect } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import useQuestionPreview from 'chameleon-src/components/QuestionPreview/hooks/useQuestionPreview';

const QuestionPreviewContainer = (props) => {
  const {
    userData,
    setQuestionPropsAction,
    firstItem,
    dynamicItems,
    hoveredItemParent,
    containerPlacement,
    qbCachedLrnQuestionsLimit,
    uuid,
    questionsContainer,
  } = props;
  const { isStudent } = userData;
  const [
    {
      hoverProps: questionPreviewProps,
      preview: questionPreview,
      previewContainer: questionPreviewContainer,
    },
  ] = useQuestionPreview({
    isAvailable: !isStudent,
    items: [firstItem],
    dynamicItems,
    hoveredItemParent,
    containerOffsetX: 80,
    containerOffsetY: 10,
    containerPlacement,
    qbCachedLrnQuestionsLimit,
    uuid,
    questionsContainer,
  });

  useEffect(() => {
    if (!isEmpty(questionPreviewProps)) {
      setQuestionPropsAction(questionPreviewProps);
    }
  }, [questionPreviewProps]);

  if (!dynamicItems.length) {
    return null;
  }

  return cloneElement(questionPreviewContainer, {
    children: questionPreview,
  });
};

QuestionPreviewContainer.propTypes = {
  firstItem: PropTypes.object.isRequired,
  hoveredItemParent: PropTypes.string,
  containerPlacement: PropTypes.string,
  questionsContainer: PropTypes.string.isRequired,
};

QuestionPreviewContainer.defaultProps = {
  hoveredItemParent: '.hover-question-parent',
  containerPlacement: 'bottom',
};

export default QuestionPreviewContainer;
